'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "selected", "onSelect", "mode", "modifiers", "language", "disabled", "month", "onMonthChange", "defaultMonth", "triggerClassName", "disabledDays", "removePortal", "yearDropdown", "fromYear", "toYear", "footer"];
import { enUS, es, pt } from 'date-fns/locale';
import { Calendar } from "../Calendar";
import { Popper, PopperContent, PopperTrigger } from "../Popper";
import { DateInput } from "./components/DateInput";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DatePicker(_ref) {
  var id = _ref.id,
    selected = _ref.selected,
    onSelect = _ref.onSelect,
    mode = _ref.mode,
    modifiers = _ref.modifiers,
    language = _ref.language,
    disabled = _ref.disabled,
    month = _ref.month,
    onMonthChange = _ref.onMonthChange,
    defaultMonth = _ref.defaultMonth,
    triggerClassName = _ref.triggerClassName,
    disabledDays = _ref.disabledDays,
    removePortal = _ref.removePortal,
    yearDropdown = _ref.yearDropdown,
    fromYear = _ref.fromYear,
    toYear = _ref.toYear,
    footer = _ref.footer,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  var locale = language === 'en' ? enUS : language === 'pt' ? pt : es;
  return /*#__PURE__*/_jsxs(Popper, {
    children: [/*#__PURE__*/_jsx(PopperTrigger, {
      disabled: disabled,
      className: triggerClassName,
      children: /*#__PURE__*/_jsx(DateInput, _objectSpread(_objectSpread({
        mode: mode,
        selected: selected,
        disabled: disabled
      }, inputProps), {}, {
        rootElement: "div"
      }))
    }), /*#__PURE__*/_jsxs(PopperContent, {
      className: "tw-w-auto tw-shadow-none",
      removePadding: true,
      removePortal: removePortal,
      children: [mode === 'single' && /*#__PURE__*/_jsx(Calendar, {
        id: id,
        mode: mode,
        selected: selected,
        onSelect: onSelect,
        locale: locale,
        initialFocus: true,
        modifiers: modifiers,
        month: month,
        onMonthChange: onMonthChange,
        defaultMonth: defaultMonth,
        yearDropdown: yearDropdown,
        fromYear: fromYear,
        toYear: toYear,
        disabled: disabledDays,
        footer: footer
      }), mode === 'range' && /*#__PURE__*/_jsx(Calendar, {
        id: id,
        mode: mode,
        selected: selected,
        onSelect: onSelect,
        locale: locale,
        initialFocus: true,
        modifiers: modifiers,
        month: month,
        onMonthChange: onMonthChange,
        defaultMonth: defaultMonth,
        yearDropdown: yearDropdown,
        fromYear: fromYear,
        toYear: toYear,
        disabled: disabledDays,
        footer: footer
      })]
    })]
  });
}